import { MarketingNav } from "@/components/marketing/MarketingNav";
import { Hero } from "@/components/landing/Hero";
import { LogoStrip } from "@/components/landing/LogoStrip";
import { Problem } from "@/components/landing/Problem";
import { Bets } from "@/components/landing/Bets";
import { Features } from "@/components/landing/Features";
import { ExtendedFeatures } from "@/components/landing/ExtendedFeatures";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { TechnologyShowcase } from "@/components/landing/TechnologyShowcase";
import { StatsBand } from "@/components/landing/StatsBand";
import { IndustriesSection } from "@/components/marketing/IndustriesSection";
import { Architecture } from "@/components/landing/Architecture";
import { SecurityCompliance } from "@/components/landing/SecurityCompliance";
import { Pricing } from "@/components/landing/Pricing";
import { FAQ } from "@/components/landing/FAQ";
import { Testimonials } from "@/components/landing/Testimonials";
import { ContactSection } from "@/components/landing/ContactSection";
import { MediaKit } from "@/components/landing/MediaKit";
import { FinalCTA } from "@/components/landing/FinalCTA";
import { Footer } from "@/components/landing/Footer";
import { SeoHead } from "@/components/SeoHead";
import { FAQ as FAQ_CONTENT } from "@/content/landing";

export default function Landing() {
  return (
    <div
      data-testid="landing-root"
      className="relative min-h-screen w-full bg-background font-body text-foreground"
    >
      <SeoHead
        title="Sema — The Semantic Layer for Enterprise AI"
        description="Connect your warehouse, let Sema infer what the data means, and answer business questions in plain English — with audit-grade governance from day one."
        keywords="semantic layer, enterprise AI, text to SQL, governed analytics, data glossary, semantic graph, self-serve analytics, DPDP compliance"
        path="/"
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Sema",
            url: "https://semalayer.com",
            logo: "https://semalayer.com/logo192.png",
            description: "The semantic layer for enterprise AI — governed, explainable text-to-SQL analytics.",
          },
          {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: FAQ_CONTENT.items.map((it) => ({
              "@type": "Question",
              name: it.q,
              acceptedAnswer: { "@type": "Answer", text: it.a },
            })),
          },
        ]}
      />
      <MarketingNav />
      <main>
        <Hero />
        <LogoStrip />
        <Problem />
        <Bets />
        <Features />
        <ExtendedFeatures />
        <HowItWorks />
        <TechnologyShowcase />
        <StatsBand />
        <IndustriesSection />
        <Architecture />
        <SecurityCompliance />
        <Pricing />
        <FAQ />
        <Testimonials />
        <ContactSection />
        <MediaKit />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}
